<template>
	<div> 
		<v-card>
			<v-toolbar class="bg-white">
				<v-card-title class="p-0">{{ $t("res_DialogTitle_PreviewTemplate") }}</v-card-title>
				<v-spacer></v-spacer>
				<v-btn @click="closeDialog" class="close-btn light-btn" icon dark>
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="d-flex flex-grow-1 overflow-auto m-0 divided_row">
				<div class="col-6 p-4" v-show="ShowBookmarksLoader" :style="bookmarksDivStyle">
					<div class="row" v-for="index in 8" :key="index">
						<div class="col-4 TamplatePreviewDiv-lbl bookmarks_TamplatePreviewDiv">
							<v-skeleton-loader  type="text">
							</v-skeleton-loader>
						</div>
						<div class="col-8 TamplatePreviewDiv-input bookmarks_TamplatePreviewDiv">
							<v-skeleton-loader  type="text">
							</v-skeleton-loader>
						</div>
					</div>
				</div> 
				<div class="col-6 p-4 left-side" id="bookmarksDiv" v-show="!ShowBookmarksLoader" :style="bookmarksDivStyle">
					<div class="row" v-for="(bookmark, index) in bookmarks" :key="index">
						<div class="col-4 bookmarks_TamplatePreviewDiv">
							{{ bookmark }}
						</div>
						<div class="col-8 bookmarks_TamplatePreviewDiv">
							<input class="form-control" v-model="bookmarkValues[bookmark]" />
						</div>
					</div>
				</div> 
				<div class="col-6 border" v-show="ShowPreviewerLoader"> <v-skeleton-loader v-bind="attrs" type="article,article,article,actions" ></v-skeleton-loader> </div>
				<div class="col-6 right-side pt-0 pb-0 bkg-grey rounded-3" 	v-show="!ShowPreviewerLoader" >
					<div v-if="empty_viewer" class="empty-viewer bkg-grey">
						<img src="/assets/images/icons/template.svg" />
						<h2>{{ $t("res_Msgs_NoTemplatesSelected") }}</h2>
						<p>{{ $t("res_Msgs_SelectViewTemplate") }}</p>
					</div> 
					<iframe :src="viewerFrameSrc" style="width: 100%; height: calc(100%)"></iframe>
				</div>
			</div>
			<v-card-actions class="gap-2 sticky-actions shadow-none" style="padding-right: 15px !important">
				<div class="row">
					<div class="col-2 offset-4  text-end">
						<v-btn @click="closeDialog" class="light-blue" style="width: 100px !important">
							{{ $t("res_ButtonText_Cancel") }}
						</v-btn> 
						<v-btn @click="bindBookmarksValues" style="width: 100px !important" class="primary ml-2 mr-2">
							{{ $t("res_ButtonText_Generate") }}
							<v-progress-circular v-show="ShowGenerateLoader" color="white" class="m-1" indeterminate :size="20"></v-progress-circular>
						</v-btn>
					</div>
				</div>
			</v-card-actions>
		</v-card>
	</div>
</template>

<style>
	.TamplatePreviewDiv-lbl .v-skeleton-loader__text {
		height: 15px;
	}
	.bookmarks_TamplatePreviewDiv {
		display: block;
		margin: auto;
	}

	.TamplatePreviewDiv-input .v-skeleton-loader__text {
		height: 37px;
	}
</style>
<script>
import axios from "axios";
import constants from "@/assets/js/constants";
export default {
	name: "TemplatePreview",
	props: { closeDialogFunc: Function, templateId: 0 },
	data: function () {
		return {
			ShowGenerateLoader: false,
			viewerFrameSrc: "",
			empty_viewer: true,
			ShowBookmarksLoader: true,
			ShowPreviewerLoader: false,
			bookmarks: [],
			bookmarkValues: {},
		};
	},
	methods: {
		closeDialog() {
			this.closeDialogFunc();
		},
		FetchTemplate() {
			this.empty_viewer = false;
			window.setViewerData("", "");
			this.viewerFrameSrc = `/resources/viewer/viewer.html?templateId=${
				this.templateId
			}&lang=${
				this.$i18n.locale
			}&defaultScale=page-width&pageMode=view&r=${new Date().getTime()}`;
		},
		GetTemplateBookmarks: function () {
			this.ShowBookmarksLoader = true;
			axios
				.get(
					constants.baseApiUrl +
						`Template/${this.templateId}/GetTemplateBookmarks`
				)
				.then((res) => {
					if (
						res &&
						res.data &&
						Array.isArray(res.data) &&
						res.data.length > 0
					) {
						this.bookmarks = res.data;
					} else {
						this.bookmarks = [];
					}
					this.ShowBookmarksLoader = false;
					for (const key in this.bookmarkValues) {
						this.bookmarkValues[key] = "";
					}
				})
				.catch((err) => console.log(err));
		},
		bindBookmarksValues() {
			this.$nextTick(() => {
				this.ShowGenerateLoader = true;
				this.ShowPreviewerLoader = true;
			});
			const bookmarkValueArray = Object.keys(this.bookmarkValues).map(
				(bookmark) => ({
					bookmarkText: bookmark,
					bookmarkValue: this.bookmarkValues[bookmark],
				})
			);
			try {
				axios
					.post(
						constants.baseApiUrl +
							`Template/${this.templateId}/ApplyBookmarks`,
						bookmarkValueArray
					)
					.then((res) => {
						var tempFilePath = res.data;
						this.viewerFrameSrc =
							"/resources/viewer/viewer.html?fileName=" +
							tempFilePath +
							"&lang=" +
							this.$i18n.locale +
							"&defaultScale=page-width&pageMode=view" +
							"&r=" +
							new Date().getTime();
					})
					.catch((err) => console.log(err))
					.finally(() => {
						this.$nextTick(() => {
							this.ShowPreviewerLoader = false;
							this.ShowGenerateLoader = false;
						});
					});
			} catch (error) {
				console.log(error);
			}
		},
	},
	computed: {
		bookmarksDivStyle() {
			const screenHeight =
				window.innerHeight || document.documentElement.clientHeight;
			const maxHeightPercentage = 78; // %
			const maxContainerHeight =
				(screenHeight * maxHeightPercentage) / 100;
			return {
				height: `${maxContainerHeight}px`,
				overflowY: "auto",
			};
		},
	},
	mounted() {
		this.GetTemplateBookmarks();
		this.FetchTemplate();
	},
	watch: {
		templateId() {
			if (this.templateId > 0) {
				this.GetTemplateBookmarks();
				this.FetchTemplate();
			}
		},
	},
};
</script>
